import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import AddIcon from "@mui/icons-material/Add";
import { logout } from "../../../pages/Login/model/authSlice";
import { useDispatch } from "react-redux";
import useAuth from "../../../hooks/useAuth";
import { endpointMap } from "../../../data/Fields";

const drawerWidth = 330;

function ResponsiveDrawer(props) {
  const dispatch = useDispatch();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const { auth } = useAuth();
  const userRole = auth?.role;

  const logoutButton = () => {
    dispatch(logout());
    navigate("/login");
  };

  const menuItems = [
    { text: "Профиль", path: "/profile" },
    { text: "Мои объекты", path: "/myProperties" },
    { text: "Добавить объект", path: "/addObject" },
    { text: "Дежурка", path: "/general" },
    ...(userRole === "admin"
      ? [
          { text: "Добавить агентов", path: "/addAgent" },
          { text: "Районы", path: "/districts" },
          { text: "Жилые помещения", path: "/residentals" },
          { text: "Категории", path: "/category" },
        ]
      : []),
    { text: "Рейтинги", path: "/ratings" },
    { text: "Показы", path: "/shows" },
    { text: "Список агентов", path: "/agentsList" },
  ];

  const drawer = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={logo} alt="logo" style={{ width: 100 }} />
      </div>

      <List>
        {menuItems.map((item) => (
          <ListItem
            key={item.text}
            disablePadding
            sx={{
              width: "auto",
              backgroundColor:
                item.path === "/addObject" ? "rgba(67, 60, 228, 1)" : "inherit",
              borderRadius: item.path === "/addObject" ? "5px" : undefined,
              marginTop: item.path === "/addObject" ? "10px" : undefined,
              marginBottom: item.path === "/addObject" ? "10px" : undefined,
            }}
          >
            <ListItemButton
              onClick={() => {
                navigate(item.path);
                setMobileOpen(false);
              }}
              sx={{
                width: "auto",
                padding: item.path === "/addObject" ? "5px 10px" : "10px",
              }}
            >
              {item.path === "/addObject" && (
                <AddIcon
                  style={{
                    color: "white",
                    marginRight: 10,
                  }}
                />
              )}
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  style: {
                    color:
                      location.pathname === item.path
                        ? "red"
                        : item.path === "/addObject"
                          ? "white"
                          : "inherit",
                    fontWeight:
                      location.pathname === item.path ? "bold" : "normal",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <div style={{ marginTop: "auto", padding: "10px" }}>
        <button
          onClick={logoutButton}
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <img
            src="/icons/logoutIcon.svg"
            alt="logo"
            style={{ width: 40, marginRight: "6px" }}
          />
          Выйти
        </button>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          display: { xs: "block", md: "none" },
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { xs: "block", md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              padding: "20px",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              padding: "20px",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { md: 2, sm: 0 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar sx={{ display: { xs: "block", md: "none" } }} />
        <Outlet />
      </Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  window: PropTypes.func,
};

export default ResponsiveDrawer;
